export default function ChiSiamoSection() {
  return (
    <section className="py-16 md:py-28 bg-[#0D0D0D]" id="chi-siamo">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Images collage */}
          <div className="relative h-[520px] hidden lg:block">
            <div className="absolute top-0 left-0 w-72 h-80 rounded-xl overflow-hidden border border-yellow-600/30">
              <img
                src="https://public.readdy.ai/ai/img_res/e8e760ec99ed69f3be5772a572d946eb.jpg"
                alt="Filmodeling - Modello professionista"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
            <div className="absolute bottom-0 right-0 w-64 h-72 rounded-xl overflow-hidden border border-yellow-600/30" style={{ bottom: '20px', right: '0px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=young%20actor%20performing%20on%20stage%20with%20dramatic%20spotlight%2C%20theater%20or%20cinema%20audition%20scene%2C%20professional%20casting%20environment%2C%20emotional%20performance%2C%20dark%20stage%20with%20golden%20theatrical%20lighting%2C%20dramatic%20arts%2C%20cinematic%20moment&width=512&height=576&seq=about02&orientation=portrait"
                alt="Filmodeling - Recitazione e cinema"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 rounded-xl overflow-hidden border-2 border-yellow-500/60" style={{ top: '55%', left: '55%' }}>
              <img
                src="https://readdy.ai/api/search-image?query=fashion%20school%20classroom%20with%20students%20practicing%20catwalk%20walk%2C%20modeling%20academy%20training%20session%2C%20elegant%20studio%20environment%2C%20professional%20fashion%20instructor%20teaching%20young%20models%2C%20warm%20golden%20studio%20lights%2C%20luxurious%20atmosphere&width=448&height=448&seq=about03&orientation=squarish"
                alt="Filmodeling - Accademia di formazione"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div
              className="absolute bottom-4 left-4 bg-black border border-yellow-600/60 rounded-xl px-6 py-4 z-10"
              style={{ boxShadow: '0 8px 32px rgba(212,175,55,0.2)' }}
            >
              <div
                className="text-3xl font-bold"
                style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
              >
                20+
              </div>
              <div
                className="text-xs text-gray-400 tracking-widest uppercase"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Anni di Eccellenza
              </div>
            </div>
          </div>

          {/* Text content */}
          <div>
            <span
              className="inline-block border border-yellow-600/60 text-yellow-500 text-xs tracking-widest uppercase px-5 py-2 rounded-full mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Chi Siamo
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              La Nostra Esperienza{' '}
              <span style={{ color: '#D4AF37' }}>al Tuo Servizio</span>
            </h2>

            <div
              className="text-gray-300 leading-relaxed space-y-4 mb-8"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300, fontSize: '15px' }}
            >
              <p>
                Filmodeling è un'accademia dedicata a chi sogna di entrare nel mondo dello
                spettacolo e a chi desidera valorizzare al massimo il proprio potenziale.
              </p>
              <p>
                La nostra missione non è solo formare professionisti, ma costruire{' '}
                <strong style={{ color: '#D4AF37' }} className="font-semibold">forma, talento, presenza e sicurezza</strong>,
                sia davanti alla macchina da presa che nella vita di tutti i giorni.
              </p>
              <p>
                Da oltre vent'anni accompagniamo i nostri allievi passo dopo passo, guidati
                da professionisti con grande esperienza nel settore, che il tuo obiettivo
                sia calcare le passerelle o recitare sul grande schermo.
              </p>
            </div>

            {/* Checklist */}
            <ul className="space-y-4 mb-10">
              {[
                'Formazione completa e mirata per modelli e attori',
                'Insegnanti professionisti attivi nel settore',
                'Percorsi personalizzati su obiettivi e talenti individuali',
                'Presenza scenica e sicurezza anche nella vita quotidiana',
                'Network e opportunità nel mondo dello spettacolo',
              ].map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base" style={{ color: '#D4AF37' }} />
                  </div>
                  <span
                    className="text-gray-300 text-sm"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            {/* Divider */}
            <div
              className="pt-8 border-t flex items-center gap-6"
              style={{ borderColor: 'rgba(212,175,55,0.2)' }}
            >
              <img
                src="https://static.readdy.ai/image/6afa39c0c3f9276f3764fc25ca77885c/3c63eba329b3d6d7fa0c54ab3415f1ec.svg"
                alt="Filmodeling"
                className="h-20 w-auto"
              />
              <p
                className="text-gray-500 text-xs italic"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '15px' }}
              >
                "Costruiamo forma, talento, presenza e sicurezza — da oltre vent'anni."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
